import { Settings } from "@mui/icons-material";
import { AppBar, Divider, Stack, Toolbar, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { HeaderButton, HeaderIconButton, LogoButton } from "./component/Components";
import LoginButton from "./component/LoginButton";
import ThemeToggle from "./component/ThemeToggle";
import { useLogin } from "../../context/Login/LoginContext";
import React from "react";

const Header = () => {
    const navigate = useNavigate();
    const { isLoggedIn, user } = useLogin();

    const LoginRequired = ({ render }: { render: JSX.Element }) => {
        if (!isLoggedIn) return <React.Fragment />;
        return render;
    }

    const AdminRequired = ({ render }: { render: JSX.Element }) => {
        if (!isLoggedIn || user?.role !== 'admin') return <React.Fragment />;
        return render;
    }

    return (
        <AppBar
            position="static"
            sx={{
                bgcolor: 'background.paper',
                color: 'text.secondary',
                boxShadow: 'none',
                borderBottom: '1px solid rgba(75, 85, 99, 0.12)'
            }}
        >
            <Toolbar sx={{ px: '12px' }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" columnGap={2} rowGap={0.5} width={1} flexWrap="wrap">
                    <Stack direction="row" alignItems="center" columnGap={2} rowGap={0.5} flexWrap="wrap">
                        <LogoButton />
                        <Stack direction="row" gap={0.1} flexWrap="wrap">
                            <AdminRequired render={
                                <>
                                    <HeaderButton to="admin">Admin</HeaderButton>
                                    <Divider orientation="vertical"
                                        sx={{ height: "24px", borderWidth: "1px", alignSelf: "center", color: "text.secondary", margin: "0 8px" }} />
                                </>
                            } />
                            <HeaderButton to="users">Users</HeaderButton>
                            <HeaderButton to="jobs">Jobs</HeaderButton>
                            <LoginRequired render={<HeaderButton to="applications">Applications</HeaderButton>} />
                        </Stack>
                    </Stack>
                    <Stack direction="row" flexShrink={0} gap={0.5} flexWrap="wrap">
                        {/* <HeaderIconButton>
                            <Search />
                        </HeaderIconButton>
                        <HeaderIconButton>
                            <NotificationsNone />
                        </HeaderIconButton>
                        <HeaderIconButton>
                            <HelpOutline />
                        </HeaderIconButton> */}
                        <ThemeToggle />
                        <HeaderIconButton onClick={() => navigate('/settings')}>
                            <Settings />
                        </HeaderIconButton>
                        <LoginButton />
                    </Stack>
                </Stack>
            </Toolbar>
        </AppBar>
    );
};

export default Header;